import { reactive } from "vue";

export const mergeTask = reactive({
    tasks: [],

    setTasks(newTasks) {
        this.tasks = newTasks;
    },
    setTaskResult(taskName, result) {
        this.tasks.forEach(element => {
            if (element.taskName == taskName) {
                element.result = result;
            }
        })
    }
})